<template>
  <div class="language">
    <!-- <div class="language-btn" @click="showBox">
      <span class="flag-icon">{{ showLabelLang }}</span>
      <van-icon name="arrow-down" />
    </div> -->
    <!-- <van-popup v-model="show" round position="bottom" :overlay-style="{ background: '#f0f0f0aa' }">
      <div class="title">{{ $t(this.langPopupTitle) }}</div>
      <div class="box">
        <van-radio-group v-model="lang">
          <van-cell-group>
            <van-cell v-for="item in list" :key="item.name" clickable @click="changeLanguage(item.name)">
              <template slot="title">
                <span class="margin-right5 vertical-middle">
                  <span :class="`flag-icon flag-icon-${countryCode[item.name]}`" style="margin-right: 6px"></span>
                  {{ item.i18n }}
                </span>
              </template>
              <template #right-icon>
                <van-radio :name="item.name" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup> -->
    <a-popover v-model="show" trigger="click" placement="bottom">
      <div class="language-btn" @click="showBox">
        <span class="flag-icon">{{ showLabelLang }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div slot="content">
        <!-- <div class="title">{{ $t(this.langPopupTitle) }}</div> -->
        <div class="box">
          <van-radio-group v-model="lang">
            <van-cell-group>
              <van-cell v-for="item in currentList" :key="item.name" clickable @click="changeLanguage(item.name)">
                <template slot="title">
                  <span class="margin-right5 vertical-middle">
                    {{ item.i18n }}
                  </span>
                </template>
                <template #right-icon>
                  <van-radio :name="item.name" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
    </a-popover>
  </div>
</template>

<script>
import { Locale } from 'vant';
import language from '@/i18n/index';
export default {
  props: ['name', 'areaList'],
  name: 'Language',
  data() {
    return {
      show: false,
      lang: 'en',
      list: [
        // { i18n: 'chinese', name: 'zh' },
        { i18n: 'Francais - FR', name: 'fr' },
        { i18n: 'English - EN', name: 'en' },
        { i18n: 'Deutsch - DE', name: 'de' },
        { i18n: 'Espaiol - ES', name: 'es' },
        { i18n: 'Italiano - IT', name: 'it' },
        { i18n: 'Русский - RU', name: 'ru' },
      ],
      countryCode: {
        zh: 'cn',
        fr: 'fr',
        en: 'us',
        de: 'de',
        it: 'it',
        es: 'es',
      },
      langPopupTitle: 'popupTitle',
    };
  },
  computed: {
    showLabelLang() {
      // 增加兜底逻辑，防止 find 找不到对象时报错
      const activeItem = this.currentList.find(item => item.name === this.lang);
      return activeItem ? activeItem.i18n : '';
    },
    currentList() {
      // 如果没有传入 areaList 或者 areaList 为空，默认显示全部或显示空（根据业务需求）
      if (!this.areaList || this.areaList.length === 0) {
        return this.list; 
      }
      
      return this.list.reduce((acc, item) => {
        // 检查 areaList 中是否存在匹配的 area_name
        const isMatch = this.areaList.some(subItem => subItem.area_name === item.name);
        
        if (isMatch) {
          acc.push(item);
        }
        return acc; // 必须返回 acc
      }, []);
    },
  },
  watch: {
    currentList() {
      if(!this.currentList.find(item => item.name === this.lang)) {
        this.lang = this.currentList[0].name;
        this.changeLanguage(this.lang);
      }
    },
    '$i18n.locale'(v) {
      if (v !== this.lang) {
        this.lang = v;
      }
    },
    areaList: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.lang) {
          const currentArea = newVal.find(item => item.area_name === this.lang);
          if (currentArea) {
            this.$emit('input', currentArea.area_id);
          }
        }
      }
    }
  },
  mounted() {
    if (localStorage.getItem('lang')) {
      this.lang = localStorage.getItem('lang');
    }
  },
  methods: {
    changeLanguage(lan) {
    this.lang = lan;
    
    // --- 新增逻辑：查找并同步 area_id ---
    if (this.areaList && this.areaList.length > 0) {
      const currentArea = this.areaList.find(item => item.area_name === lan);
      if (currentArea) {
        // 同步 area_id 到父组件的 v-model
        this.$emit('input', currentArea.area_id); 
      }
    }
    // --------------------------------

    const messages = language._vm.messages;
    this.$i18n.locale = this.lang;
    Locale.use(this.lang, messages[this.lang]);
    this.$toast.success(this.$t('changeLanSes'), this.lang);
    
    localStorage.setItem('lang', this.lang);
    this.$emit('changeLangCall', this.lang);
    this.show = false;
  },
    showBox() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss">
.language {
  width: 100%;
  height: 50px;
  &-btn {
    position: absolute;
    top: 0;
    padding-top: 2px;
    right: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    color: #010101;
    border-radius: 4px;
    gap: 8px;
    font-size: 17px;
    .flag-icon {
      width: 100%;
      height: 100%;
    }
  }
  .box {
    width: 100%;
    height: 100%;
    padding: 0 6px 12px;
    overflow-y: scroll;
  }
  .title {
    height: 48px;
    padding-left: 20px;
    line-height: 48px;
    font-weight: 600;
    font-size: 15px;
    border-bottom: 1px solid #f0f0f0;
  }
}
.ant-popover-inner-content {
  .van-cell-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .van-cell {
    padding: 0;
    gap: 10px;
  }
}
</style>
